<template>
  <div class="home" ref="recommend">
    <img style="width: 65%; height: 75%;" v-if="logoUi.productRecommendUrl" :src="logoUi.productRecommendUrl" alt="">
  </div>
</template>

<script>
import { getLogo } from '@/utils/intConfiguration';

export default {
  name: 'Recommend',
  data() {
    return {
      logoUi: getLogo(),
    };
  },
  mounted() {
    this.$refs.recommend.style.backgroundColor = '#fff';
  },
};
</script>

<style lang="less" scoped>
.home {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
